/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 7/8/13
 * Time: 2:00 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var Marionette = require('marionette');
    var Template = require("templates/trayMenu.tmpl");

    var TrayMenuItemView = require("views/TrayMenuItemView");
    var TrayMenu;
    TrayMenu = Marionette.CompositeView.extend({
        itemViewContainer: ".tray-menu-container",
        itemView: TrayMenuItemView,
        tagName: "div",
        template: Template,
        ui: {
            trayMenu: ".tray-menu"
        },
        collectionEvents: {
            "add": "_checkVisibility"
        },
        _checkVisibility: function () {
            if(!this.isRendered) {
                return;
            }

            if (this.collection && this.collection.length > 0) {
                this.ui.trayMenu.show();
            }
        },
        onRender: function () {
            this.isRendered = true;
            this._checkVisibility();
        }
    });
    return TrayMenu;
});

